export enum EnvironmentType {
  development = "development",
  staging = "staging",
  testing = "testing",
  production = "production"
}
